export const GLOBAL_ALERT_CONTAINER_ID = 'blink-v2-global-banner-alert-portal-container';
export const V1_GLOBAL_ALERT_CONTAINER_ID = 'blink-v1-global-banner-alert-portal-container';
export var GlobalAlertTestId;
(function (GlobalAlertTestId) {
    GlobalAlertTestId["BANNER"] = "global-alert-banner";
    GlobalAlertTestId["TOAST"] = "global-alert-toast";
})(GlobalAlertTestId || (GlobalAlertTestId = {}));
export const initialState = {
    currentBannerId: '',
    currentToastId: '',
    bannerAlertProps: { message: '', isVisible: false, onClose: () => false },
    toastAlertProps: { message: '', isVisible: false, onClose: () => false },
};
export var Action;
(function (Action) {
    Action[Action["UPDATE_BANNER"] = 0] = "UPDATE_BANNER";
    Action[Action["UPDATE_TOAST"] = 1] = "UPDATE_TOAST";
})(Action || (Action = {}));
//# sourceMappingURL=global-alert-context.util.js.map